module.exports = __webpack_public_path__ + "images/emoji/moyai.d95f6510dadb0db3e2e1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/moyai.png
// module id = 1F14
// module chunks = 13